import React from 'react';

const ChatSidePanelToggleButton = ({
  isOpen,
  onToggle,
  className = '',
  label = '詳細パネル',
  iconOnly = false,
}) => {
  const actionLabel = isOpen ? '閉じる' : '開く';

  return (
    <button
      type="button"
      className={`chat-side-panel-toggle${iconOnly ? ' chat-side-panel-toggle--icon-only' : ''}${
        className ? ` ${className}` : ''
      }`}
      onClick={onToggle}
      aria-label={`${label}を${actionLabel}`}
      title={`${label}を${actionLabel}`}
    >
      <i
        className={`fa-solid ${isOpen ? 'fa-angles-right' : 'fa-angles-left'}`}
        aria-hidden="true"
      ></i>
      {!iconOnly ? <span className="chat-side-panel-toggle__label">{actionLabel}</span> : null}
    </button>
  );
};

export default ChatSidePanelToggleButton;
